var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          staticStyle: { margin: "10px" },
          attrs: { text: _vm.column_data[_vm.term - 1][1] }
        },
        _vm._l(_vm.column_data, function(col, index) {
          return _c(
            "b-dropdown-item",
            {
              key: index,
              on: {
                click: function($event) {
                  return _vm.select(index + 1)
                }
              }
            },
            [_vm._v(_vm._s(col[1]))]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("layout-1", {
        staticStyle: { width: "100%", height: "calc(100vh - 125px)" },
        attrs: {
          table_name: "Reports",
          id: _vm.pageid,
          searchbar: false,
          navbar: false,
          term: _vm.term,
          termchange: true
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18ef19c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18ef19c5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Reports.vue
// module id = 733
// module chunks = 0